import { Component, inject } from '@angular/core';
import { RecommendedQuantityPerResourceService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  RecommendedQuantityPerResourceCreateDto,
  RecommendedQuantityPerResourceDto,
  RecommendedQuantityPerResourceExcelDownloadDto,
  RecommendedQuantityPerResourceUpdateDto,
} from 'orchestrator';
import { RECOMMENDEDQUANTITYPERRESOURCE_CONFIG, RECOMMENDEDQUANTITYPERRESOURCE_FIELDS } from './recommended-quantity-per-resource.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-recommended-quantity-per-resource',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, RecommendedQuantityPerResourceService, ConfirmationService],
  templateUrl: './recommended-quantity-per-resource.html',
  styleUrl: './recommended-quantity-per-resource.scss',
})
export class RecommendedQuantityPerResource extends BaseCrudComponent<
  RecommendedQuantityPerResourceDto,
  RecommendedQuantityPerResourceCreateDto,
  RecommendedQuantityPerResourceUpdateDto,
  RecommendedQuantityPerResourceExcelDownloadDto
> {
  service = inject(RecommendedQuantityPerResourceService);
  config = RECOMMENDEDQUANTITYPERRESOURCE_CONFIG;
  fields = RECOMMENDEDQUANTITYPERRESOURCE_FIELDS;

  protected prepareUpdateDto(data: any, selected: RecommendedQuantityPerResourceDto): RecommendedQuantityPerResourceUpdateDto {
    return {
      plantTypeId: data.plantTypeId,
      quantity: data.quantity,
      plantationTypeId: data.plantationTypeId,
      isManual: data.isManual,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'RecommendedQuantityPerResource';
  }
}
